import React from "react";
import {
  AppBar,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Image } from "../Image";
import styled from "@emotion/styled";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { useChatImageGalleryStore } from "@store/chat-image-gallery";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)`
  height: 100vh;
  @supports (height: 100dvh) {
    height: 100dvh;
  }
  & .MuiDialog-paper {
    height: 100vh;
    @supports (height: 100dvh) {
      height: 100dvh;
    }
  }
`;

const CustomAppBar = styled(AppBar)`
  background-color: ${(p) => p.theme.colors.background};
`;

const CustomDialogContent = styled(DialogContent)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 6rem;
  img {
    object-fit: contain;
    width: 100% !important;
    max-width: 100% !important;
    height: calc(100vh - 16rem);
    @supports (height: 100dvh) {
      height: calc(100dvh - 16rem);
    }
  }

  ${(p) => p.theme.media.mobileDown} {
    padding: 2rem 0rem;
  }
`;

export const ImageGallery = () => {
  const setChatGalleryImage = useChatImageGalleryStore(
    (state) => state.setChatGalleryImage
  );
  const image = useChatImageGalleryStore((state) => state.image);
  const isOpen = useChatImageGalleryStore((state) => state.isOpen);

  const onClose = () => {
    setChatGalleryImage(null);
  };

  return (
    <CustomDialog
      fullWidth
      maxWidth="xl"
      open={isOpen}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <CustomAppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography
            sx={{ flex: 1, textTransform: "capitalize" }}
            variant="h6"
            component="div"
          >
            {image?.alt ?? "Image"}
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </CustomAppBar>
      <CustomDialogContent id="image-gallery-dialog-content">
        <Image {...image} canZoomIn={false} fallback={<CircularProgress />} />
      </CustomDialogContent>
    </CustomDialog>
  );
};
